import React, { useState } from 'react';
import _get from 'lodash.get';
import copy from 'copy-to-clipboard';
import { Text } from '@shootsta/common-react';
import '../styles/_video-id.scss';

const COPIED = 'Copied';
const COPY = 'Copy';

const ICON_MAP = {
  [COPIED]: 'success',
  [COPY]: 'duplicate'
} as const;

function setStatus(
  setState: (
    arg1:
      | ((arg1: undefined | string) => undefined | string)
      | undefined
      | string
  ) => void,
  status: undefined | string
) {
  return () => {
    setState(status);

    if (status === COPIED) {
      setTimeout(setState, 1000);
    }
  };
}

function copyToClipboard(videoId: string, callback: () => void) {
  return () => {
    copy(videoId);

    callback();
  };
}

function withNoEventPropagation(fn: any) {
  return (e: any) => {
    e.stopPropagation();
    e.preventDefault();

    fn(e);
  };
}

export default function VideoId({ videoId }: { videoId: string }) {
  const [status, setState] = useState();

  return (
    <button
      className="video-id"
      onMouseEnter={setStatus(setState, COPY)}
      onMouseLeave={setStatus(setState)}
      type="button"
      onClick={withNoEventPropagation(
        copyToClipboard(videoId, setStatus(setState, COPIED))
      )}
      disabled={status === COPIED}
      data-testid="videoId"
    >
      <Text
        prefixIcon={_get(ICON_MAP, status)}
        prefixIconColor="white"
        highlighted
        darkTheme
        noMargin
      >
        {status || videoId}
      </Text>
    </button>
  );
}
